module.exports = __webpack_public_path__ + "80d66ecf2694eba4a9a315f82a00dff6.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/images/img-logo-social.png
// module id = 680
// module chunks = 114276838955818